import script from "./Manage_platform.vue?vue&type=script&setup=true&name=Mannage_platform&lang=js"
export * from "./Manage_platform.vue?vue&type=script&setup=true&name=Mannage_platform&lang=js"

import "./Manage_platform.vue?vue&type=style&index=0&id=7373c25c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7373c25c"]])

export default __exports__